/**
 * 统一采用<SvgIcon/>引入图表
 * 取自antd-Icon的以type属性值作为name
 */

import React from 'react'

import './index.scss'
import icons from '@/assets/icons'

const iconIds = icons.map(icon => {
  const id = icon.default.id || ''
  return id.split('icon-')[1]
})

export default (props) => {
  const {name, ...otherProps} = props
  if (iconIds.indexOf(name) !== -1) {
    return (
      <svg className={['svg-icon', otherProps.className].filter(Boolean).join(' ')} style={otherProps.style} aria-hidden="true">
        <use xlinkHref={`#icon-${name}`}></use>
      </svg>
    )
  } else {
    return null
  }
}
